import React, { useEffect, useState } from 'react';
import axios from 'axios';


const NomineeFpsCards = ({ distCode, afsoCode,afsoName ,districtName}) => {
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!distCode || !afsoCode) return;

    axios.get(`${process.env.REACT_APP_URL}/api/nominee/fps`, {
      params: { distCode, afsoCode }
    })
      .then((response) => {
  setData(response.data);
  calculateTotals(response.data); 
  setLoading(false);
})

      .catch((err) => {
        console.error(err);
        setError("Failed to fetch FPS data");
        setLoading(false);
      });
  }, [distCode, afsoCode]);


  const calculateRowTotal = (row) => {
    return (
      (row.admRc || 0) +
      (row.admTagRc || 0) +
      (row.admNotTagRc || 0) +
      (row.rcAgedNominee || 0) +
      (row.rcFailNominee || 0) +
      (row.rcOtheNominee || 0) +
      (row.rcNominee || 0) +
      (row.fpsAgedNominee || 0) +
      (row.fpsFailNominee || 0) +
      (row.fpsLepNominee || 0) +
      (row.fpsBedNominee || 0) +
      (row.fpsNominee || 0) +
      (row.nomineeCards || 0) +
      (row.nomDrawnCards || 0) +
      (row.selfDrawn || 0) +
      (row.vroDrawn || 0)
    );
  };

  const calculateTotals = (rows) => {
    const totalObj = {
      admRc: 0,
      admTagRc: 0,
      admNotTagRc: 0,
      rcAgedNominee: 0,
      rcFailNominee: 0,
      rcOtheNominee: 0,
      rcNominee: 0,
      fpsAgedNominee: 0,
      fpsFailNominee: 0,
      fpsLepNominee: 0,
      fpsBedNominee: 0,
      fpsNominee: 0,
      nomineeCards: 0,
      nomDrawnCards: 0,
      selfDrawn: 0,
      vroDrawn: 0,
    };

    rows.forEach(row => {
      Object.keys(totalObj).forEach(key => {
        totalObj[key] += row[key] || 0;
      });
    });

    setTotals(totalObj);
  };

  const totalOfTotals = calculateRowTotal(totals);

  return (
    <div className="wrapper">
      <h2 style={{ 
    textAlign: "center", 
    color: "#111111ff", 
    fontSize: "18px", 
    textDecoration: "underline" 
  }}>
 {districtName}-{afsoName} - FPS wise cards mapped with Nominee Abstract
  </h2>

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && !error && data.length > 0 && (
        <>
<table style={{ width: '80%', margin: '0 auto', borderCollapse: 'collapse' }}>
            <thead>
              <tr className="tableheader">
                <th rowSpan={3}>Sl.No</th>
                <th rowSpan={3}>FPS Id</th>
                <th rowSpan={2} colSpan={3}>Admin Approved</th>
                <th colSpan={10}>Cards With Nominee</th>
                <th rowSpan={3}>Total<br />Drawn Cards</th>
                <th rowSpan={3}>Self<br />Drawn Cards</th>
                <th rowSpan={3}>Nominee<br />Drawn Cards</th>
                <th rowSpan={3}>Total</th>
              </tr>
              <tr className="tableheader">
                <th colSpan={4}>RC Base</th>
                <th colSpan={5}>FPS Base</th>
                <th rowSpan={2}>Total</th>
              </tr>
              <tr className="tableheader">
                <th>Approved</th>
                <th>Tagged<br />Nominee</th>
                <th>Not Tagged<br />Nominee</th>
                <th>Aged</th>
                <th>Failed</th>
                <th>Others</th>
                <th>Total</th>
                <th>Aged</th>
                <th>Failed</th>
                <th>Leprosy</th>
                <th>Bedridden</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td align="right">{row.fpsId}</td>
                  <td align="right">{row.admRc}</td>
                  <td align="right">{row.admTagRc}</td>
                  <td align="right">{row.admNotTagRc}</td>
                  <td align="right">{row.rcAgedNominee}</td>
                  <td align="right">{row.rcFailNominee}</td>
                  <td align="right">{row.rcOtheNominee}</td>
                  <td align="right">{row.rcNominee}</td>
                  <td align="right">{row.fpsAgedNominee}</td>
                  <td align="right">{row.fpsFailNominee}</td>
                  <td align="right">{row.fpsLepNominee}</td>
                  <td align="right">{row.fpsBedNominee}</td>
                  <td align="right">{row.fpsNominee}</td>
                  <td align="right">{row.nomineeCards}</td>
                  <td align="right">{row.nomDrawnCards}</td>
                  <td align="right">{row.selfDrawn}</td>
                  <td align="right">{row.vroDrawn}</td>
                  <td align="right">{calculateRowTotal(row)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="tableheader" style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>
                <td colSpan={2} align="center">Total</td>
                <td align="right">{totals.admRc}</td>
                <td align="right">{totals.admTagRc}</td>
                <td align="right">{totals.admNotTagRc}</td>
                <td align="right">{totals.rcAgedNominee}</td>
                <td align="right">{totals.rcFailNominee}</td>
                <td align="right">{totals.rcOtheNominee}</td>
                <td align="right">{totals.rcNominee}</td>
                <td align="right">{totals.fpsAgedNominee}</td>
                <td align="right">{totals.fpsFailNominee}</td>
                <td align="right">{totals.fpsLepNominee}</td>
                <td align="right">{totals.fpsBedNominee}</td>
                <td align="right">{totals.fpsNominee}</td>
                <td align="right">{totals.nomineeCards}</td>
                <td align="right">{totals.nomDrawnCards}</td>
                <td align="right">{totals.selfDrawn}</td>
                <td align="right">{totals.vroDrawn}</td>
                <td align="right">{totalOfTotals}</td>
              </tr>
            </tfoot>
          </table>
        </>
      )}
    </div>
  );
};

export default NomineeFpsCards;
